<script setup lang="ts">
import type { JournalListItemDTO } from '~/shared/api/client/journals/journals.dto';
import JournalCover from './JournalCover.vue';

const props = defineProps<{
  issue: JournalListItemDTO;
}>();

const PRICE_NOTE = 'с учётом НДС 22%, печатная версия, самовывоз';

/* "10 000₽" of the layout */
const price = computed(() =>
  props.issue.price === null
    ? null
    : `${props.issue.price.toLocaleString('ru-RU')}₽`,
);
</script>

<template>
  <aside :class="$style.summary">
    <div :class="$style.coverBox">
      <JournalCover
        :title="issue.title"
        :src="issue.cover?.file_url"
        :class="$style.cover"
      />
    </div>
    <!-- An issue with no price is settled by invoice: the block simply ends -->
    <div v-if="price" :class="$style.price">
      <p :class="$style.amount">{{ price }}</p>
      <p :class="$style.note">{{ PRICE_NOTE }}</p>
    </div>
  </aside>
</template>

<style module lang="scss">
.summary {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--space-5x);
  padding: var(--space-6x) var(--space-4x);
  background-color: var(--color-gray-bg-2);
}

/*
 * The cover keeps the width the layout gives it and stays centred in whatever
 * the column is; its own box takes the height from the proportions of the file
 */
.coverBox {
  width: 100%;
  max-width: 240px;
  margin: 0 auto;
}

.amount {
  @include text_h4;
  color: var(--color-black-1);
  margin: 0;
}

.note {
  @include text_body2;
  color: var(--color-black-2);
  margin: var(--space-1x) 0 0;
}

@media (max-width: 899px) {
  /*
   * Above the form the block is a band of its own: the cover shrinks and the
   * price moves under it, centred, the way the mobile layout draws it
   */
  .summary {
    padding: var(--space-4x) var(--space-2x);
    gap: var(--space-3x);
    text-align: center;
  }

  .coverBox {
    max-width: 200px;
  }
}
</style>
